'use client'

import styled from "styled-components";
import BaseInput from "@/components/UI/Form/Inputs/BaseInput/BaseInput";

export const PasswordInputStyled = styled(BaseInput)``